module.exports = __webpack_public_path__ + "img/pre_new.0e3b0d71.png";